export const MetricsTabIds = {
    Filespace: 'filespace',
    FileSystem: 'fileSystem',
    ObjectStore: 'objectStore',
    MetaStore: 'metaStore',
    Network: 'network',
};
